// Use optimized images for better performance
import ImageText from '../image-text';
import { Helmet } from 'react-helmet-async';
import './consulting.scss';

const Consulting = () => {
  return (
      <div className="flow-page">
        <Helmet>
          <title>Consulting Services | Watchelm</title>
          <meta name="description" content="Explore our consulting services to enhance your business processes and technology adoption." />
        </Helmet>

        {/* First Feature section */}
        <div className="section-container">  

          {/* Consulting services sections using ImageText components */}
          <ImageText 
            title="Strategic Technology Consulting"
            subtitle="Expert guidance for your digital journey"
            content={`<p>Our strategic consulting services help you navigate the complexities of modern technology landscapes. Whether you're planning a GenAI rollout, a cloud migration, implementing DevOps practices, or seeking to optimize your existing systems, our experts provide the insights you need.</p>
              <p>We take a holistic approach to consulting, considering your business goals, existing infrastructure, and team capabilities to deliver recommendations that drive real business value.</p>`}
            imageSrc="/assets/images/optimized/Consultancy/image1"
            imageAlt="Strategic Consulting Services"            buttonText="Contact Us for Consulting"
            buttonLink="/contact#subject=consulting"
            imageOnRight={false}
            gradientTitle="green"
          />
      </div>
      {/* Zigzag connector to the right */}
      <div className="section-connector zigzag-right">
        {/* Arrow head removed */}
      </div>
    
    {/* Second Feature section*/}
    <div className="section-container">
      <ImageText 
        title="Mapforce Implementation"
        subtitle="Data integration specialists"
        content={`<p>Our team have been working with Mapforce and the related Altova products for over 20 years.
         Our team have helped organisations of all different sizes with their Altova Mapforce implementations, helping organizations to streamline their data integration processes. 
         We specialize in:</p>
         
         <ul>
           <li>Custom data mapping solutions</li>
           <li>EDI integration</li>
           <li>Database to XML/JSON conversions</li>
           <li>API integrations</li>
           <li>Process automation using FlowForce</li>
         </ul>
           <p>With our guidance, you can significantly reduce development time, eliminate manual coding errors, and create maintainable data transformation workflows.</p>`}
        imageSrc="/assets/images/optimized/Consultancy/image7" 
        imageAlt="Mapforce Implementation"        buttonText="Contact Our Experts"
        buttonLink="/contact#subject=consulting"
        imageOnRight={true}
        backgroundColor="#f8f9fa"
        gradientTitle="red-to-green"
      />
    </div>
    </div>

  );
}

export default Consulting;
